export default __webpack_public_path__ + "static/media/greeting16.c2c58d54.png";